export default {
  'lang.english': 'अंग्रेज़ी',
  'lang.hindi': 'हिंदी',
  'lang.telugu': 'तेलुगु',

  'nav.master': 'डैशबोर्ड',
  'nav.dashboard': 'अवलोकन',
  'nav.customers': 'ग्राहक',
  'nav.finance': 'वित्त',
  'nav.loans': 'हाथ ऋण',
  'nav.accounts': 'खाते',
  'nav.report': 'रिपोर्ट',
  'nav.audit': 'ऑडिट लॉग',
  'nav.erp': 'फाइनेंस ERP',
  'nav.consultancy': 'परामर्श',
  'nav.expenses': 'खर्च',
  'nav.employees': 'कर्मचारी और वेतन',
  'nav.settings': 'सेटिंग्स',
  'nav.home': 'होम',
  'nav.clients': 'क्लाइंट',
  'nav.financeShort': 'वित्त',
  'nav.loansShort': 'ऋण',
  'nav.clientsShort': 'ग्राहक',
  'nav.settingsShort': 'सेट',
  'nav.workspace': 'वर्कस्पेस',
  'nav.collections': 'वसूली',
  'nav.support': 'सहायता',
  'nav.contact': 'संपर्क',
  'nav.businessHours': 'व्यावसायिक समय डेस्क',
  'nav.billingCollections': 'बिलिंग और वसूली',

  'common.save': 'सहेजें',
  'common.saved': 'सहेजा गया',
  'common.cancel': 'रद्द करें',
  'common.export': 'निर्यात',
  'common.exportFile': 'फ़ाइल निर्यात करें',
  'common.search': 'खोजें',
  'common.searchWorkspace': 'वर्कस्पेस खोजें…',
  'common.back': 'वापस',
  'common.profile': 'प्रोफ़ाइल',
  'common.actions': 'कार्रवाई',
  'common.entryDate': 'प्रविष्टि तिथि',
  'common.logout': 'लॉग आउट',
  'common.borrower': 'उधारकर्ता',
  'common.facilities': 'सुविधाएँ',
  'common.principal': 'मूलधन',
  'common.collected': 'वसूल',
  'common.outstanding': 'बकाया',
  'payment.howWePaid': 'हमने कैसे भुगतान किया (वितरण)',
  'payment.howTheyPaid': 'उन्होंने कैसे भुगतान किया (संग्रह)',
  'payment.via': 'भुगतान माध्यम',
  'payment.cash': 'नकद',
  'payment.online': 'बैंक',
  'payment.split': 'नकद + बैंक',
  'payment.cashAmount': 'नकद राशि (₹)',
  'payment.bankAmount': 'बैंक राशि (₹)',
  'payment.splitTotalHint': 'नकद + बैंक = ₹{sum} (₹{total} के बराबर होना चाहिए)',
  'payment.selectBank': 'कंपनी बैंक चुनें',
  'payment.paidBy': 'भुगतानकर्ता / संदर्भ',
  'payment.cashCollections': 'नकद संग्रह',
  'payment.bankCollections': 'बैंक संग्रह',
  'payment.cashDisbursements': 'नकद वितरण',
  'payment.bankDisbursements': 'बैंक वितरण',
  'payment.cashTaken': 'नकद प्राप्त',
  'payment.cashGiven': 'नकद दिया',
  'payment.accountCredited': 'बैंक क्रेडिट',
  'payment.accountDebited': 'बैंक डेबिट',
  'payment.collectionsIn': 'वसूली अंदर',
  'payment.loanDisbursed': 'दिया गया ऋण',
  'payment.addBankInSettings': 'ऑनलाइन ट्रैकिंग के लिए सेटिंग्स → बैंक में खाते जोड़ें।',
  'payment.selectBankRequired': 'ऑनलाइन भुगतान के लिए बैंक चुनें',
  'payment.paidByRequired': 'भुगतानकर्ता या लेनदेन संदर्भ दर्ज करें',
  'common.nextDue': 'अगली देय',
  'common.amount': 'राशि',
  'common.noMatch': 'कोई ग्राहक मेल नहीं खाता',
  'common.appliesWorkspace': 'केवल इस वर्कस्पेस पर लागू',
  'common.add': 'जोड़ें',
  'common.edit': 'संपादित करें',
  'common.delete': 'हटाएँ',
  'common.new': 'नया',
  'common.close': 'बंद करें',
  'common.submit': 'जमा करें',
  'common.confirm': 'पुष्टि करें',
  'common.loading': 'लोड हो रहा है…',
  'common.status': 'स्थिति',
  'common.date': 'तिथि',
  'common.phone': 'फ़ोन',
  'common.email': 'ईमेल',
  'common.name': 'नाम',
  'common.total': 'कुल',
  'common.view': 'देखें',
  'common.filter': 'फ़िल्टर',
  'common.sort': 'क्रमबद्ध करें',
  'common.all': 'सभी',
  'common.select': 'चुनें',
  'common.selectLoan': 'ऋण चुनें',
  'common.swipeTable': 'अधिक कॉलम के लिए तालिका बाएँ या दाएँ स्वाइप करें',
  'common.readOnly': 'केवल पढ़ने की अनुमति',
  'common.finance': 'वित्त',
  'common.handLoans': 'हाथ ऋण',
  'common.line': 'लाइन',
  'common.customer': 'ग्राहक',
  'common.created': 'बनाया गया',
  'common.updated': 'अपडेट किया गया',
  'common.records': 'रिकॉर्ड',
  'common.inPeriod': 'अवधि में',

  'status.paid': 'भुगतान किया',
  'status.due': 'देय',
  'status.scheduled': 'निर्धारित',
  'status.active': 'सक्रिय',
  'status.seized': 'जब्त',
  'status.closed': 'बंद',
  'status.readyToClose': 'बंद करने के लिए तैयार',
  'status.disabled': 'अक्षम',
  'status.default': 'डिफ़ॉल्ट',

  'login.signIn': 'साइन इन',
  'login.signingIn': 'साइन इन हो रहा है…',
  'login.emailPlaceholder': 'ईमेल या मोबाइल नंबर',
  'login.password': 'पासवर्ड',
  'login.showPassword': 'पासवर्ड दिखाएँ',
  'login.hidePassword': 'पासवर्ड छिपाएँ',
  'login.welcome': 'वापसी पर स्वागत है',
  'login.subtitle': 'अपने वर्कस्पेस में साइन इन करें',
  'login.createAccount': 'खाता बनाएँ',
  'login.enterOtp': 'OTP दर्ज करें',
  'login.otpSubtitle': 'वापस जाएँ और ईमेल + पासवर्ड से साइन इन करें।',
  'login.signUpSubtitle': 'अपना संगठन वर्कस्पेस सेट अप करें।',
  'login.or': 'या',
  'login.alreadyHaveAccount': 'पहले से खाता है?',
  'login.newOrganization': 'नया संगठन?',
  'login.register': 'पंजीकरण',
  'login.verifyOtp': 'OTP सत्यापित करें',

  'audit.title': 'ऑडिट ट्रेल',
  'audit.subtitle': 'गतिविधि लॉग',
  'audit.auditorMode': 'ऑडिटर मोड — केवल पढ़ने की अनुमति',
  'audit.disclaimer':
    'ये प्रबंधन रिकॉर्ड हैं — वैधानिक ऑडिट रिपोर्ट नहीं।',
  'audit.statTotal': 'कुल इवेंट',
  'audit.statToday': 'आज',
  'audit.statLogins': 'साइन इन / आउट',
  'audit.statUpdates': 'अपडेट',
  'audit.statSecurity': 'सुरक्षा',
  'audit.searchPlaceholder': 'यूज़र, लोन, एक्शन खोजें…',
  'audit.refresh': 'रीफ्रेश',
  'audit.actionFilter': 'एक्शन प्रकार',
  'audit.tableTitle': 'गतिविधि लॉग',
  'audit.events': 'इवेंट',
  'audit.empty': 'अभी कोई ऑडिट इवेंट नहीं',
  'audit.emptyHint': 'टीम के वर्कस्पेस उपयोग पर इवेंट यहाँ दिखेंगे।',
  'audit.exportTitle': 'ऑडिट ट्रेल एक्सपोर्ट',
  'audit.detailTitle': 'ऑडिट एंट्री',
  'audit.actor': 'यूज़र',
  'audit.entity': 'रिकॉर्ड',
  'audit.reason': 'कारण',
  'audit.device': 'डिवाइस',
  'audit.changes': 'बदलाव',
  'audit.oldValue': 'पुराना मान',
  'audit.newValue': 'नया मान',
  'audit.action': 'एक्शन',
  'audit.summary': 'सारांश',
  'audit.prev': 'पिछला',
  'audit.next': 'अगला',
} as const;
